import { FieldNamesMarkedBoolean } from 'react-hook-form';
import { IChannelValues, IChannelKeyContent } from 'src/types/venueForm.types';

const isChannelsDataChanged = (dirtyChannels: Partial<Readonly<FieldNamesMarkedBoolean<IChannelValues>>>): boolean => {
  if (!dirtyChannels) return false;

  const channelsValues = Object.values(dirtyChannels);

  return channelsValues.some((channel: Partial<Readonly<FieldNamesMarkedBoolean<IChannelKeyContent>>>) =>
    Object.values(channel).some((value: boolean) => value),
  );
};

export default isChannelsDataChanged;
